<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>In-Out Master Plan</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <p><b>Name</b></p>
            <v-text-field outlined dense type="text" v-model="master_name"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <p><b>In-Time</b></p>
            <v-text-field outlined dense type="time" v-model="intime"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <p><b>Out-Time</b></p>
            <v-text-field outlined dense type="time" v-model="outtime"></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" dense v-if="master_name && intime && outtime">
          <v-btn color="warning" @click="savePlanMaster()" :loading="loader">Add</v-btn>
        </v-row>
      </v-card>
      <v-card class="box" v-if="show_detail_card">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>In-Out Master Plan Details</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="12">
            <!-- <v-data-table  :headers="headers_day_list" :items="day_list" item-key="id"  class="elevation-1 "  :items-per-page="-1">
             <template v-slot:[`item.intime`]="{ item }">
                    <v-text-field  outlined dense type="time" v-model="intime" ></v-text-field>
            </template>
<template v-slot:[`item.isweeklyoff`]="{ item }">
                    <input type="checkbox" v-model="isweeklyoff" />
            </template>
<template v-slot:[`item.outtime`]="{ item }">
                <v-text-field  outlined dense type="time" v-model="outtime" ></v-text-field>
            </template>
</v-data-table> -->
            <v-simple-table class="elevation-1" :items-per-page="-1">
              <template>
                <thead>
                  <tr>
                    <th>Sr.No.</th>
                    <th>Day</th>
                    <th>Is-Weekly Off</th>
                    <th>In-Time</th>
                    <th>Out-Time</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in day_list" :key="i">
                    <td>{{ i + 1 }}</td>
                    <td>{{ item.day }}</td>
                    <td>
                      <input type="checkbox" v-model="item.isweeklyoff" name="day_id" />
                      <!-- <td><input type="checkbox" v-model="item.isweeklyoff" name="day_id" @change="disableInOut(item)"/> -->
                      <!-- <input type="hidden" name="day_id" value="item.isweeklyoff" /> -->
                    </td>
                    <td>
                      <v-text-field outlined dense type="time" v-model="item.intime" :disabled="item.isweeklyoff">
                        <!-- <input type="hidden" name="intimearray" value="item.intime" /> -->
                      </v-text-field>
                    </td>
                    <td>
                      <v-text-field outlined dense type="time" v-model="item.outtime" :disabled="item.isweeklyoff">
                        <!-- <input type="hidden" name="ouutimearray" value="item.outtime" /> -->
                      </v-text-field>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <p><b>From Date</b></p>
            <v-text-field outlined dense type="date" v-model="fromdate"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <p><b>To Date</b></p>
            <v-text-field outlined dense type="date" v-model="todate"></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" dense v-if="fromdate && todate">
          <v-btn color="warning" @click="savePlanMasterAndDetails()">Save</v-btn>
        </v-row>
      </v-card>

      <v-card class="box" v-if="inoutPlanMaster_list != ''">
        <v-row>
          <v-col cols="12" sm="6"></v-col>

          <v-col cols="12" sm="6"><v-text-field v-model="search" append-icon="search" label="Search" single-line
              hide-details></v-text-field></v-col>
        </v-row>
        <v-data-table :headers="headers" :items="inoutPlanMaster_list" :items-per-page="-1" :search="search">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>In-Out Master Plan List</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>

            </v-toolbar>
          </template>
          <template v-slot:[`item.details`]="{ item }">
            <v-avatar size="50">
              <v-icon class="mr-4 v-icon-size" color="green" @click="getMasterDetails(item)">mdi-note-multiple</v-icon>
            </v-avatar>
          </template>
          <template v-slot:[`item.weekly_details`]="{ item }">
            <v-avatar size="50">
              <v-icon class="mr-4 v-icon-size" color="green"
                @click="getWeeklyPlanDetails(item)">mdi-note-multiple</v-icon>
            </v-avatar>
          </template>
          <template v-slot:[`item.edit_plan`]="{ item }">
            <v-avatar size="35">
              <v-icon class="mr-4 v-icon-size" color="red" @click="edit_plan_master(item)">mdi-pencil</v-icon>
            </v-avatar>
          </template>
          <template v-slot:[`item.delete`]="{ item }">
            <v-avatar size="35">
              <v-icon class="mr-4 v-icon-size" color="red"
                @click="deleteInOutPlanMasterAndDetails(item)">mdi-trash-can</v-icon>
            </v-avatar>
          </template>
        </v-data-table>
      </v-card>
      <v-card class="box" v-if="show_plan_detail_card">
        <v-data-table :headers="headers_details" :items="in_out_datewise_plan_details" :items-per-page="-1">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>In-Out Master Plan Datewise Details</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.isweeklyoff`]="{ item }">
            <span v-if="item.isweeklyoff">
              <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
            </span>
            <span v-else>
              <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <v-avatar size="35">
              <v-icon class="mr-2 v-icon-size" color="success" @click="editDetail(item)">mdi-pencil</v-icon>
            </v-avatar>
          </template>
          <template v-slot:[`item.delete`]="{ item }">
            <v-avatar size="35">
              <v-icon class="mr-4 v-icon-size" color="red" @click="deleteInOutPlanDetails(item)">mdi-trash-can</v-icon>
            </v-avatar>
          </template>
        </v-data-table>
      </v-card>
      <v-card class="box" v-if="show_weekly_plan_detail_card">
        <v-data-table :headers="headers_weekly_details" :items="in_out_weekly_plan_details" :items-per-page="-1">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>In-Out Weekly Plan Details</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.isweeklyoff`]="{ item }">
            <span v-if="item.isweeklyoff">
              <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
            </span>
            <span v-else>
              <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <v-icon class="mr-2 v-icon-size" @click="editWeeklyDetails(item)" color="success">mdi-pencil</v-icon>
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="dialog_edit" persistent scrollable="false" max-width="1200px"
        transition="dialog-bottom-transition">
        <v-card class="box">
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>Edit In-Out Master Details</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-row justify="center" dense>
              <v-col cols="12" sm="3">
                <p><b>Day</b></p>
                <v-text-field outlined dense type="text" v-model="editedItem.day" readonly filled></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>In-Time</b></p>
                <v-text-field outlined dense type="time" v-model="editedItem.intime" :readonly="editedItem.isweeklyoff"
                  :filled="editedItem.isweeklyoff"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Out-Time</b></p>
                <v-text-field outlined dense type="time" v-model="editedItem.outtime" :readonly="editedItem.isweeklyoff"
                  :filled="editedItem.isweeklyoff"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Is-Weekly Off</b></p>
                <input type="checkbox" v-model="editedItem.isweeklyoff" />
              </v-col>
            </v-row>
          </v-card-text>
          <br />
          <v-row justify="center">
            <v-btn color="primary" :loading="loader" @click="saveEditDetails()">Update</v-btn>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="dialog_edit = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog_weekly_edit" persistent scrollable="false" max-width="1200px"
        transition="dialog-bottom-transition">
        <v-card class="box">
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>Edit Weekly In-Out Master Details</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-row justify="center" dense>
              <v-col cols="12" sm="3">
                <p><b>Day</b></p>
                <v-text-field outlined dense type="text" v-model="editedWeeklyItem.day" readonly filled></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>In-Time</b></p>
                <v-text-field outlined dense type="time" v-model="editedWeeklyItem.intime"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Out-Time</b></p>
                <v-text-field outlined dense type="time" v-model="editedWeeklyItem.outtime"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Is-Weekly Off</b></p>
                <input type="checkbox" v-model="editedWeeklyItem.isweeklyoff" />
              </v-col>
            </v-row>
            <v-row justify="center" dense>
              <center>Note* - If any changes made in weekly in-out, one has to goto edit section of "In-Out Master Plan
                List"
                and click "Apply plan". Once done, confirm the changes from Day wise detail section of "In-Out Master
                Plan
                List"</center>
            </v-row>
          </v-card-text>
          <br />
          <v-row justify="center">
            <v-btn color="primary" :loading="loader" @click="saveEditWeeklyDetails()">Update</v-btn>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="dialog_weekly_edit = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="show_plan_edit_card" persistent scrollable="false" max-width="1200px"
        transition="dialog-bottom-transition">
        <v-card class="box">
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>Extend Plan</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-row justify="center" dense>
              <v-col cols="12" sm="3">
                <p><b>Name</b></p>
                <v-text-field outlined dense v-model="edited_plan_Item.name" readonly></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>From Date</b></p>
                <v-text-field outlined dense type="date" v-model="edited_plan_Item.fromdate"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>To Date</b></p>
                <v-text-field outlined dense type="date" v-model="edited_plan_Item.todate"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <br />
          <v-row justify="center">
            <v-btn color="primary" :loading="loader" @click="saveEditPlanMasterDetails()">Apply Plan</v-btn>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="show_plan_edit_card = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    loader: false,
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    master_name: "",
    search: "",
    intime: "",
    outtime: "",
    inoutPlanMaster_list: [],
    master_present: false,
    show_detail_card: false,
    singleSelect: false,
    selected: [],
    isweeklyoff: false,
    day_id: [],
    intimearray: [],
    ouutimearray: [],
    inoutbuffertimemaster_list: [],
    day_list: [],
    fromdate: new Date().toISOString().slice(0, 10),
    todate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1)
      .toISOString()
      .substr(0, 10),
    headers: [
      { text: "Sr No", value: "count" },
      { text: "Name", value: "name" },
      { text: "From Date", value: "fromdate" },
      { text: "To Date", value: "todate" },
      { text: "Weekly Plan Details", value: "weekly_details" },
      { text: "Day Wise Details", value: "details" },
      { text: "Edit", value: "edit_plan" },
      { text: "Delete", value: "delete" },
    ],
    headers_details: [
      { text: "Sr No", value: "count" },
      { text: "Master", value: "inoutplanmaster" },
      { text: "In Time", value: "intime" },
      { text: "Out Time", value: "outtime" },
      { text: "Day", value: "day" },
      { text: "Date", value: "todaysdate" },
      { text: "Day No", value: "erpcalenderintegerday" },
      { text: "Is-Weekly Off", value: "isweeklyoff" },
      { text: "Edit", value: "edit" },
      { text: "Delete", value: "delete" },
    ],
    headers_weekly_details: [
      { text: "Sr No", value: "count" },
      { text: "Master", value: "inoutplanmaster" },
      { text: "In Time", value: "intime" },
      { text: "Out Time", value: "outtime" },
      { text: "Day", value: "day" },
      { text: "Is-Weekly Off", value: "isweeklyoff" },
      { text: "Edit", value: "edit" },
    ],
    //  headers_day_list:[
    // { text: "Day", value: "day" },
    // { text: "Is-Weekly Off", value: "isweeklyoff" },
    // { text: "In-Time", value: "intime" },
    // { text: "Out-Time", value: "outtime" },
    // ],
    in_out_datewise_plan_details: [],
    show_plan_detail_card: false,
    dialog_edit: false,
    in_out_weekly_plan_details: [],
    show_weekly_plan_detail_card: false,
    editedItem: {
      id: "",
      intime: "",
      outtime: "",
      day: "",
      day_id: "",
      isweeklyoff: "",
    },
    editedWeeklyItem: {
      id: "",
      intime: "",
      outtime: "",
      day: "",
      day_id: "",
      isweeklyoff: "",
    },
    edited_plan_Item: {
      id: "",
      fromdate: "",
      todate: "",
      name: "",
    },
    show_plan_edit_card: false,
    dialog_weekly_edit: false,
  }),
  methods: {
    saveEditWeeklyDetails() {
      this.overlay = true;
      this.loader = true;
      axios
        .post("/EmployeeBiometric/saveEditWeeklyDetails", this.editedWeeklyItem)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.in_out_weekly_plan_details =
              res.data.in_out_weekly_plan_details;
            this.dialog_weekly_edit = false;
            this.showSnackbar("green", "Details Updated Successfully...");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
        });
    },
    editWeeklyDetails(item) {
      this.editedWeeklyItem.id = item.id;
      this.editedWeeklyItem.intime = item.intime;
      this.editedWeeklyItem.outtime = item.outtime;
      this.editedWeeklyItem.day = item.day;
      this.editedWeeklyItem.day_id = item.day_id;
      this.editedWeeklyItem.isweeklyoff = item.isweeklyoff;
      this.dialog_weekly_edit = true;
    },
    saveEditPlanMasterDetails() {
      this.overlay = true;
      this.loader = true;
      axios
        .post(
          "/EmployeeBiometric/saveEditPlanMasterDetails",
          this.edited_plan_Item
        )
        .then((res) => {
          if (res.data.flag == "YES") {
            this.inoutPlanMaster_list = res.data.inoutPlanMaster_list;
            this.show_plan_edit_card = false;
            this.showSnackbar("green", "Details Updated Successfully...");
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
        });
    },
    edit_plan_master(item) {
      this.edited_plan_Item.name = item.name;
      this.edited_plan_Item.id = item.id;
      this.edited_plan_Item.fromdate = item.fromdate_edit;
      this.edited_plan_Item.todate = item.todate_edit;
      this.show_plan_edit_card = true;
    },
    getWeeklyPlanDetails(item) {
      const data = {
        master_id: item.id,
      };
      this.overlay = true;
      axios
        .post("/EmployeeBiometric/getInOutWeeklyPlanDetails", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.in_out_weekly_plan_details =
              res.data.in_out_weekly_plan_details;
            this.show_weekly_plan_detail_card = true;
            this.show_plan_detail_card = false;
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
            this.master_present = true;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    deleteInOutPlanDetails(item) {
      if (!confirm("Are You Sure You Want To Delete...?")) return;
      const data = {
        details_id: item.id,
      };
      this.overlay = true;
      this.loader = true;
      axios
        .post("/EmployeeBiometric/deleteInOutPlanDetails", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.in_out_datewise_plan_details =
              res.data.in_out_datewise_plan_details;
            this.dialog_edit = false;
            this.showSnackbar("green", "Details Updated Successfully...");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
        });
    },
    deleteInOutPlanMasterAndDetails(item) {
      if (!confirm("Are You Sure You Want To Delete...?")) return;
      const data = {
        master_id: item.id,
      };
      this.overlay = true;
      this.loader = true;
      axios
        .post("/EmployeeBiometric/deleteInOutPlanMasterAndDetails", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.in_out_datewise_plan_details =
              res.data.in_out_datewise_plan_details;
            this.dialog_edit = false;
            this.showSnackbar("green", "Details Deleted Successfully...");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
        });
    },

    saveEditDetails() {
      this.overlay = true;
      this.loader = true;
      axios
        .post("/EmployeeBiometric/saveEditDetails", this.editedItem)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.in_out_datewise_plan_details =
              res.data.in_out_datewise_plan_details;
            this.dialog_edit = false;
            this.showSnackbar("green", "Details Updated Successfully...");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
        });
    },
    editDetail(item) {
      this.editedItem.id = item.id;
      this.editedItem.intime = item.intime;
      this.editedItem.outtime = item.outtime;
      this.editedItem.day = item.day;
      this.editedItem.day_id = item.day_id;
      this.editedItem.isweeklyoff = item.isweeklyoff;
      this.dialog_edit = true;
    },
    getMasterDetails(item) {
      const data = {
        master_id: item.id,
      };
      this.overlay = true;
      axios
        .post("/EmployeeBiometric/getInOutPlanMasterDetails", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.in_out_datewise_plan_details =
              res.data.in_out_datewise_plan_details;
            this.show_plan_detail_card = true;
            this.show_weekly_plan_detail_card = false;
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
            this.master_present = true;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    // disableInOut(item){
    //     // alert("item::"+item.intime)
    //     // alert("item::"+item.outtime)
    //     item.intime=null
    //     item.outtime=null
    // },
    savePlanMasterAndDetails() {
      (this.intimearra = []), (this.ouutimearray = []), (this.day_id = []);
      for (var i = 0; i < this.day_list.length; i++) {
        if (this.day_list[i].isweeklyoff) {
          this.day_id.push(this.day_list[i].id);
        }
        this.intimearray.push(this.day_list[i].intime);
        this.ouutimearray.push(this.day_list[i].outtime);
      }
      const data = {
        master_name: this.master_name,
        intime: this.intime,
        outtime: this.outtime,
        fromdate: this.fromdate,
        todate: this.todate,
        isweeklyoff: this.isweeklyoff,
        day: this.day_id,
        intimearray: this.intimearray,
        ouutimearray: this.ouutimearray,
      };
      this.overlay = true;
      this.loader = true;
      axios
        .post("/EmployeeBiometric/saveInoutPlanMasterAndDetails", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.inoutPlanMaster_list = res.data.inoutPlanMaster_list),
              this.showSnackbar("green", "Saved Successfully...");
            this.show_detail_card = false;
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
            this.master_present = true;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
          (this.intimearray = []), (this.ouutimearray = []), (this.day_id = []);
          // this.selected_date=""
        });
    },
    savePlanMaster() {
      const data = {
        master_name: this.master_name,
        intime: this.intime,
        outtime: this.outtime,
      };
      this.overlay = true;
      axios
        .post("/EmployeeBiometric/saveInoutPlanMaster", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.inoutPlanMaster_list = res.data.inoutPlanMaster_list),
              (this.day_list = res.data.day_list),
              (this.show_detail_card = true);
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
            this.master_present = true;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    onLoad() {
      axios
        .post("EmployeeBiometric/inOutTimePlanMasterHome")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.inoutPlanMaster_list = res.data.inoutPlanMaster_list),
              (this.overlay = false);
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
/* .box2 {
  overflow-x: hidden;
  width: 98%;
} */
</style>